import React, { useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getServiceById, updateService } from "../../redux/Slice/serviceslice";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";

// Form validation schema using Yup
const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Service type is required"),
});

const EditService = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector((state) => state.message);
   const { serviceDetails, totalPages } = useSelector((state) => state.service);
  console.log("Services:",serviceDetails);
  
  const id = params?.id;

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(getServiceById(id))
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
        toast.error("Failed to fetch service details.");
      });
  }, [dispatch, id]);

  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);

  const formik = useFormik({
    initialValues: {
      name: serviceDetails?.name || "",
      features: serviceDetails?.features || [{ key: "", value: "" }],
      status: serviceDetails?.status || true,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const updatedFeatures = values.features.filter((feature) => feature.key.trim() !== "");
      const payload = {
        ...values,
        features: updatedFeatures,
        name: values.name
      };

      dispatch(setLoading(true));
      dispatch(updateService({ id, formData: payload })).unwrap()
        .then(() => {
          dispatch(setLoading(false));
          navigate('/services');
        })
        .catch(() => {
          dispatch(setLoading(false));
        });
    },
  });

  const handleAddFeature = () => {
    formik.setFieldValue("features", [...formik.values.features,{ key: "", value: "" }]);
  };

  const handleRemoveFeature = (index) => {
    const updatedFeatures = [...formik.values.features];
    updatedFeatures.splice(index, 1);
    formik.setFieldValue("features", updatedFeatures);
  };

  return (
    <Box
      sx={{
        padding: 4,
        border: "1px solid #ccc",
        borderRadius: 2,
        maxWidth: 600,
        margin: "auto",
      }}
    >
      <Typography variant="h5" marginBottom={3}>
        Edit Service
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        {/* Service Type */}
        <Box marginBottom={4}>
          <Typography variant="body1" marginBottom={1}>
            Service Name
          </Typography>
          <TextField
                            fullWidth
                            placeholder="Enter Service Name"
                            variant="outlined"
                            name='name'
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.name &&
                              Boolean(formik.errors.name)
                            }
                            helperText={
                              formik.touched.name &&
                              formik.errors.name
                            }
                          />
                    {formik.touched.name && formik.errors.name && (
                      <Typography variant="caption" color="error">
                        {formik.errors.name}
                      </Typography>
                    )}
          {/* <Select
            fullWidth
            variant="outlined"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && Boolean(formik.errors.name)}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Service (Select)
            </MenuItem>
            <MenuItem value="Lead Management">Lead Management</MenuItem>
            <MenuItem value="Chatbot Management">Chatbot Management</MenuItem>
            <MenuItem value="Showcase Management">Showcase Management</MenuItem>
            <MenuItem value="Quote Management">Quote Management</MenuItem>
          </Select>
          {formik.touched.name && formik.errors.name && (
            <Typography variant="caption" color="error">
              {formik.errors.name}
            </Typography>
          )} */}
        </Box>

        {/* Features Section */}
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: 2,
            padding: 2,
            marginBottom: 4,
          }}
        >
          <Typography variant="h6" marginBottom={2}>
            Features
          </Typography>
          {formik.values.features.map((feature, index) => (
            <Grid container spacing={2} key={index} sx={{ marginBottom: 2 }}>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  placeholder="Feature Key"
                  variant="outlined"
                  name={`features[${index}].key`}
                  value={feature.key}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.features?.[index]?.key &&
                    Boolean(formik.errors.features?.[index]?.key)
                  }
                  helperText={
                    formik.touched.features?.[index]?.key &&
                    formik.errors.features?.[index]?.key
                  }
                />
              </Grid>
              <Grid item xs={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton
                  color="error"
                  onClick={() => handleRemoveFeature(index)}
                >
                  <RemoveCircle />
                </IconButton>
              </Grid>
            </Grid>
          ))}
          <Button
            variant="contained"
            color="success"
            startIcon={<AddCircle />}
            onClick={handleAddFeature}
          >
            Add Feature
          </Button>
        </Box>

        {/* Submit Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: 4,
          }}
        >
          <Button type="submit" variant="contained" color="primary">
            Update Service
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default EditService;
